import moment from "moment";

import { VideoProject } from "@/services/bedrock";

import { getCoachKanbanColumnId } from "./coachKanbanColumns";

function formatStatusDate(date: string | null | undefined): string | null {
  if (!date) return null;
  return moment(date).format("MMM D, YYYY [at] h:mm a");
}

function statusDateForLabel(videoProject: VideoProject, isRevision: boolean): string | null | undefined {
  if (isRevision) {
    return videoProject.updatedDate || videoProject.statusDate || videoProject.createdDate;
  }
  return videoProject.statusDate || videoProject.createdDate;
}

export function coachKanbanStatusLabel(videoProject: VideoProject): string | null {
  const columnId = getCoachKanbanColumnId(videoProject.status);
  if (!columnId) return null;

  const isRevision = columnId === "editing" && (videoProject.revisionCount ?? 0) > 0;
  const formatted = formatStatusDate(statusDateForLabel(videoProject, isRevision));
  if (!formatted) return null;

  switch (columnId) {
    case "editing":
      return isRevision ? `Requested revision on ${formatted}` : `Submitted for editing on ${formatted}`;
    case "ready_to_post":
      return `Finished editing on ${formatted}`;
    case "scheduled":
      return `Scheduled to post on ${formatted}`;
    case "post_failed":
      return `Failed to post on ${formatted}`;
    case "posted":
      return `Posted on ${formatted}`;
  }
}
